import React from 'react';
import { useSelector } from 'react-redux';
import '../../../shared/components/layout/StoreDashboardLayout.css';
import ErrorBoundary from '../../../shared/components/ErrorBoundary';
import StoreManageView from '../components/StoreManageView';
import useStoreManageController from '../hooks/useStoreManageController';

const StoreManage = ({ sections = [], request, onToast, onSectionsUpdated }) => {
  const storeToken = useSelector((state) => state.store.storeToken);
  const storeUuid = useSelector((state) => state.store.storeUuid);
  const storeMallUuid = useSelector((state) => state.store.storeMallUuid);
  const storeName = useSelector((state) => state.store.storeName);

  const controller = useStoreManageController({
    sections,
    request,
    onToast,
    onSectionsUpdated,
    page: 'sections',
    storeToken,
    storeUuid,
    storeMallUuid,
    storeName
  });

  return (
    <ErrorBoundary level="feature">
      <StoreManageView
        controller={controller}
        storeName={storeName}
        storeUuid={storeUuid}
      />
    </ErrorBoundary>
  );
};

export default StoreManage;
